import * as React from 'react';

import {REACTIONS} from '../timeline/reaction-bar/consts';
import type {Reaction} from '../timeline/reaction-bar/types';

type Props = {
    reactionType: Reaction;
    size: number;
};

export function ReactionEmoji(props: Props) {
    // @ts-expect-error
    const emoji = REACTIONS[props.reactionType].unicode;

    return <span style={{fontSize: `${props.size}px`}}>{emoji}</span>;
}
